import { stats, features } from '@/mocks/home';

export default function FeatureSection() {
  return (
    <section className="py-14 md:py-20">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 md:gap-6 mb-14">
          {stats.map((stat) => (
            <div
              key={stat.label}
              className="text-center p-5 rounded-xl bg-background-100"
            >
              <div className="text-2xl md:text-3xl font-bold text-primary-500 font-heading">
                {stat.value}
              </div>
              <div className="text-sm text-foreground-600 mt-1">{stat.label}</div>
            </div>
          ))}
        </div>

        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            为什么选择糖豆视频？
          </h2>
          <p className="text-sm text-foreground-600 mt-2">
            我们致力于为您提供最优质的观影体验
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {features.map((feature) => (
            <div
              key={feature.title}
              className="p-5 rounded-xl bg-background-100 text-center"
            >
              <div className="w-12 h-12 rounded-xl bg-primary-100 flex items-center justify-center mx-auto mb-4">
                <i className={`${feature.icon} text-xl text-primary-500`}></i>
              </div>
              <h3 className="text-base font-bold text-foreground-950 mb-2">
                {feature.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}